<mat-sidenav-container>
  <mat-sidenav #sidenav disableClose mode="over" position="end">
    <help-ticket-detail *ngIf="selectedRecord" [record]="selectedRecord"
    (exit)="sidenav.close()"
    (markClosed)="markTicketClosed(selectedRecord)"
    ></help-ticket-detail>
  </mat-sidenav>
  <mat-sidenav-content>
    <search-list-new matSort [defaultSort]="{
    direction: 'desc',
    active: 'dateCreated'
  }" [displayedColumns]="['user', 'ticket', 'text', 'assignedUser', 'dateCreated']" (itemSelected)="onSelect($event)"
      [resultGetter]="search.bind(this)"
      [showManagerToggle]="true"
       localStorageId="help-ticket-queue">
      <ng-container matColumnDef="user">
        <mat-header-cell *matHeaderCellDef class="sortable">From</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="font-weight-bold mat-light-text">
            {{ row.creator.fullName }}
          </span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ticket">
        <mat-header-cell *matHeaderCellDef class="sortable">Ticket Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.ticketName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="text">
        <mat-header-cell *matHeaderCellDef style="flex-grow: 0; flex-shrink: 0; flex-basis: 30%;"
          class="sortable">Text</mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex-grow: 0; flex-shrink: 0; flex-basis: 30%;">
          <div class="ticket-text">
            {{ row.text }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="assignedUser">
        <mat-header-cell *matHeaderCellDef class="sortable">Assigned To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.assignedUser?.fullName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dateCreated">
        <mat-header-cell *matHeaderCellDef class="sortable">Created</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.dateCreated | date: 'shortDate' }}
        </mat-cell>
      </ng-container>
    </search-list-new>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #closeDialogTemplate let-data>
  <h2 mat-dialog-title>Mark ticket as solved?</h2>
  <mat-dialog-content>
    <div class="mat-typography">
      Please describe the solution. Closing the ticket cannot be undone.
      <mat-form-field class="w-100">
        <textarea matInput rows="4" [(ngModel)]="data.reason"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" class="button-text" [disabled]="!data.reason" [mat-dialog-close]="data.reason">Solve</button>
    <button mat-flat-button class="button-text" [mat-dialog-close]="null">Cancel</button>
  </mat-dialog-actions>
</ng-template>